import React, { useEffect, useState } from "react";
import ArrowBackIos from "../../assets/images/misc/arrow_back_ios_new.png";
import SectionStatistic from "components/about/SectionStatistic";
import { getInstitutional, InstitutionalResponse } from "services/PageService";
import founder from "../../assets/images/profile/danda-papa.jpg";
import cofounder from "../../assets/images/profile/ana2.jpg";

import aPagano from "../../assets/images/profile/andrea-pagano.jpg";
import aPrisco from "../../assets/images/profile/andreia-prisco.jpg";
import cacau from "../../assets/images/profile/cacau-haenel-martins.jpg";
import danielly from "../../assets/images/profile/danielly-urbanski-fischer.jpg";
import ericka from "../../assets/images/profile/ericka-moura-de-gouveia.jpg";
import isabella from "../../assets/images/profile/isabella-de-medina-velletri.jpg";
import sachs from "../../assets/images/profile/sachs.jpg";
import anatrevas from "../../assets/images/profile/ana-trevas.jpg";
import romita from "../../assets/images/profile/romita.jpg";
import Link from "componentsTemplate/Link";
import aboutService from "../../services/AboutService";
import { create } from "lodash";
import Placeholder from "../../assets/placeholder.png";

const AboutUs: React.FC = () => {
  const [institutional, setInstitutional] =
    useState<InstitutionalResponse | null>(null);
  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;
  const [banner, setBanner] = useState("");
  const [banner2, setBanner2] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getInstitutional(4);
        setInstitutional(data);
      } catch (error) {
        // Lidar com erros, se necessário
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!institutional) return;

    const bannersBase = `${urlBaseApi}/storage/images/institutional/banners/`;
    const mainBanner =
      institutional.banners?.find((e) => e.name === "Banner quem somos") ??
      institutional.banners?.[0];
    const secondaryBanner =
      institutional.banners?.find((e) => e.name === "Banner quem somos 2") ??
      institutional.banners?.[1];

    if (mainBanner?.banner_path) {
      setBanner(`${bannersBase}${mainBanner.banner_path}`);
    }
    if (secondaryBanner?.banner_path) {
      setBanner2(`${bannersBase}${secondaryBanner.banner_path}`);
    }
  }, [institutional, urlBaseApi]);

  const [about, setAbout]: any = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAbout();
  }, []);

  const getAbout = async () => {
    setLoading(true); // start loading
    await aboutService
      .getAbout()
      .then((response: any) => {
        setAbout(response.data);
        setLoading(false);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;

  const createFundadora = () => {
    return about.fundadoras.map((item: any, index: number) => {
      //se index for par usa uma div se for impar usa outra div
      if (index % 2 === 0) {
        return (
          <div className="flex w-full flex-col lg:flex-row items-center justify-center gap-y-20 gap-x-20">
            <div className="w-60 sm:w-[25rem] lg:w-[40rem] rounded-lg overflow-hidden">
              <img
                className="w-full h-3/4 shadow-xl object-cover grayscale"
                alt="founder"
                src={`${urlBase}/storage/images/ambassadors/photos/${item.photo_path}`}
                onError={(e: any) => {
                  e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                  e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                }}
              />
              <div className="flex flex-col h-1/4 items-center justify-center gap-4 px-4 py-4 bg-[#A27F59]">
                <div className="w-full [font-family:'Poppins-SemiBold',Helvetica] font-semibold text-x30dark-gray line-clamp-1 sm:line-clamp-none text-base sm:text-xl lg:text-3xl">
                  {item.name}
                </div>
                <div className="w-full whitespace-pre-wrap [font-family:'Poppins-Medium',Helvetica] font-medium text-[#FFF] text-sm sm:text-lg lg:text-xl mt-5">
                  {item.role}
                  {/* <br />
                    comunidade Radar */}
                </div>
              </div>
            </div>
            <div className="flex w-full flex-col gap-y-10">
              <div>
                <div className="flex flex-col items-start relative gap-y-6">
                  <p className="flex gap-x-4 flex-col sm:flex-row [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-5xl">
                    <span className="text-[#a27f59]">{item.role}</span>
                    {/* <span className="text-white">Radar</span> */}
                  </p>
                  <p
                    className="relative [font-family:'Poppins-Medium',Helvetica] font-medium text-white text-base text-justify"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></p>
                </div>
              </div>
              <div className="px-4">
                <div className="flex items-center justify-center px-0 pt-[20px] relative">
                  <p
                    className="[font-family:'Poppins-Medium',Helvetica] font-medium  text-white text-base text-justify"
                    dangerouslySetInnerHTML={{
                      __html: item.founder_description,
                    }}
                  ></p>
                  <img
                    className="absolute w-[85px] h-[85px] top-[-2rem] left-[-3rem]"
                    alt="Arrow back ios new"
                    src={ArrowBackIos}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="flex w-full flex-col lg:flex-row items-center justify-center gap-y-20 gap-x-20 ">
            <div className="flex w-full flex-col gap-y-10">
              <div>
                <div className="flex flex-col items-start relative gap-y-6">
                  <p className="mt-8 flex gap-x-4 flex-col sm:flex-row [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-5xl">
                    <span className="text-[#a27f59]">{item.role}</span>
                    {/* <span className="text-white">Radar</span> */}
                  </p>
                  <p
                    className="relative [font-family:'Poppins-Medium',Helvetica] font-medium text-white text-base text-justify"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></p>
                </div>
              </div>
              <div className="px-4">
                <div className="flex items-center justify-center px-0 pt-[20px] relative">
                  <p
                    className="[font-family:'Poppins-Medium',Helvetica] font-medium  text-white text-base text-justify"
                    dangerouslySetInnerHTML={{
                      __html: item.founder_description,
                    }}
                  ></p>
                  <img
                    className="absolute w-[85px] h-[85px] top-[-2rem] left-[-3rem]"
                    alt="Arrow back ios new"
                    src={ArrowBackIos}
                  />
                </div>
              </div>
            </div>
            <div className="w-60 sm:w-[25rem] lg:w-[40rem] rounded-lg overflow-hidden">
              <img
                className="w-full h-3/4 shadow-xl object-cover grayscale"
                alt="founder"
                src={`${urlBase}/storage/images/ambassadors/photos/${item.photo_path}`}
                onError={(e: any) => {
                  e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                  e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                }}
              />
              <div className="flex flex-col h-1/4 items-center justify-center gap-4 px-4 py-4 bg-[#A27F59]">
                <div className="w-full [font-family:'Poppins-SemiBold',Helvetica] font-semibold text-x30dark-gray line-clamp-1 sm:line-clamp-none text-base sm:text-xl lg:text-3xl">
                  {item.name}
                </div>
                <div className="w-full whitespace-pre-wrap [font-family:'Poppins-Medium',Helvetica] font-medium text-[#FFF] text-sm sm:text-lg lg:text-xl">
                  {item.role}
                  {/* <br />
                                    comunidade Radar */}
                </div>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  const createEmbaixadoras = () => {
    return about.embaixadoras.map((item: any, index: number) => {
      if (index % 2 === 0) {
        return (
          <div className="flex w-full flex-col lg:flex-row items-center justify-center gap-y-20 gap-x-20  bg-primary-50 dark:bg-gray-400 shadow-xl rounded-lg">
            <div className="overflow-hidden scale-110 ml-4 sm:ml-10 rounded-xl w-60 md:w-80 2xl:w-96 shadow-xl">
              <img
                className="w-full h-40 md:h-60 lg:h-80 2xl:h-96 grayscale object-cover"
                src={`${urlBase}/storage/images/ambassadors/photos/${item.photo_path}`}
                style={{ height: "100%" }}
                onError={(e: any) => {
                  e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                  e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                }}
              />
              <div className="flex flex-col overflow-hidden h-24 md:h-28 items-center justify-between py-2 px-2 sm:px-4 md:px-6 bg-[#695339] dark:bg-neutral-900/95">
                <span className="text-start line-clamp-1 sm:line-clamp-none w-full [font-family:'Poppins-SemiBold',Helvetica] font-semibold text-white text-base lg:text-xl">
                  {item.name}
                </span>
                <div className="text-start w-full h-12 [font-family:'Poppins-Medium',Helvetica] font-medium text-[#FFF] text-xs sm:text-sm lg:text-base">
                  {item.local_description}
                </div>
              </div>
            </div>
            <span
              className="text-left w-full h-fit mx-16 [font-family:'Poppins-SemiBold',Helvetica] text-[#262626] text-sm sm:text-sm lg:text-base p-2"
              dangerouslySetInnerHTML={{ __html: item.description }}
            ></span>
          </div>
        );
      } else {
        return (
          <div className="flex w-full flex-col lg:flex-row items-center justify-center gap-y-20 gap-x-20  bg-primary-50 dark:bg-gray-400 shadow-xl rounded-lg">
            <span
              className="text-left w-full h-fit mx-16 [font-family:'Poppins-SemiBold',Helvetica] text-[#262626] text-sm sm:text-sm lg:text-base p-2"
              dangerouslySetInnerHTML={{ __html: item.description }}
            ></span>
            <div className="overflow-hidden scale-110 mr-4 sm:mr-10 rounded-xl w-60 md:w-80 2xl:w-96 shadow-xl">
              <img
                className="w-full h-40 md:h-60 lg:h-80 2xl:h-96 grayscale object-cover"
                src={`${urlBase}/storage/images/ambassadors/photos/${item.photo_path}`}
                style={{ height: "100%" }}
                onError={(e: any) => {
                  e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                  e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                }}
              />
              <div className="flex flex-col overflow-hidden h-24 md:h-28 items-center justify-between py-2 px-2 sm:px-4 md:px-6 bg-[#695339] dark:bg-neutral-900/95">
                <span className="text-start line-clamp-1 sm:line-clamp-none w-full [font-family:'Poppins-SemiBold',Helvetica] font-semibold text-white text-base lg:text-xl">
                  {item.name}
                </span>
                <div className="text-start w-full h-12 [font-family:'Poppins-Medium',Helvetica] font-medium text-[#FFF] text-xs sm:text-sm lg:text-base">
                  {item.local_description}
                </div>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  const createEmbaixadorasInternacional = () => {
    return about.internacional.map((item: any, index: number) => {
      if (index % 2 === 0) {
        return (
          <div className="flex w-full flex-col lg:flex-row items-center justify-between items-center bg-[#262626] dark:bg-gray-400 shadow-xl rounded-lg gap-y-20 gap-x-20 ">
            <div className="overflow-hidden scale-110 ml-4 sm:ml-10 rounded-xl w-60 md:w-80 2xl:w-96 shadow-xl">
              <img
                className="w-full h-40 md:h-60 lg:h-80 2xl:h-96 grayscale object-cover"
                src={`${urlBase}/storage/images/ambassadors/photos/${item.photo_path}`}
                style={{ height: "100%" }}
                onError={(e: any) => {
                  e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                  e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                }}
              />
              <div className="flex flex-col overflow-hidden h-24 md:h-28 items-center justify-between py-2 px-2 sm:px-4 md:px-6 bg-[#A27F59]">
                <span className="text-start line-clamp-1 sm:line-clamp-none w-full [font-family:'Poppins-SemiBold',Helvetica] font-semibold text-[#262626] text-base lg:text-xl">
                  {item.name}
                </span>
                <div className="text-start w-full h-12 [font-family:'Poppins-Medium',Helvetica] font-medium text-[#FFF] text-xs sm:text-sm lg:text-base">
                  {item.local_description}
                </div>
              </div>
            </div>
            <span
              className="text-left mx-16 w-full h-fit [font-family:'Poppins-SemiBold',Helvetica] text-[#262626] text-sm sm:text-sm lg:text-base p-2 text-white"
              dangerouslySetInnerHTML={{ __html: item.description }}
            ></span>
          </div>
        );
      } else {
        return (
          <div className="flex w-full flex-col lg:flex-row items-center justify-between items-center bg-[#262626] dark:bg-gray-400 shadow-xl rounded-lg gap-y-20 gap-x-20 ">
            <span
              className="text-left mx-16 w-full h-fit [font-family:'Poppins-SemiBold',Helvetica] text-[#262626] text-sm sm:text-sm lg:text-base p-2 text-white"
              dangerouslySetInnerHTML={{ __html: item.description }}
            ></span>
            <div className="overflow-hidden scale-110 mr-4 sm:mr-10 rounded-xl w-60 md:w-80 2xl:w-96 shadow-xl">
              <img
                className="w-full h-40 md:h-60 lg:h-80 2xl:h-96 grayscale object-cover"
                src={`${urlBase}/storage/images/ambassadors/photos/${item.photo_path}`}
                style={{ height: "100%" }}
                onError={(e: any) => {
                  e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                  e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                }}
              />
              <div className="flex flex-col overflow-hidden h-24 md:h-28 items-center justify-between py-2 px-2 sm:px-4 md:px-6 bg-[#A27F59]">
                <span className="text-start line-clamp-1 sm:line-clamp-none w-full [font-family:'Poppins-SemiBold',Helvetica] font-semibold text-[#262626] text-base lg:text-xl">
                  {item.name}
                </span>
                <div className="text-start w-full h-12 [font-family:'Poppins-Medium',Helvetica] font-medium text-[#FFF] text-xs sm:text-sm lg:text-base">
                  {item.local_description}
                </div>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  return (
    <div>
      <section>
        <div
          className="flex bg-bottom bg-cover sm:h-[300px] xl:h-[696px]"
          style={{ backgroundImage: `url(${banner})` }}
        >
          <div className="backdrop-sepia backdrop-brightness-50 backdrop-blur-sm flex h-full w-full items-end justify-start">
            <div className="flex flex-row ml-8 my-4 sm:ml-20 sm:mb-10 md:ml-20 md:mb-10 lg:ml-72 xl:ml-72 2xl:ml-72 lg::mb-40 xl:mb-40 2xl:mb-40">
              <div className="columns-1 w-[15px] h-[170px] bg-[#A27F59] bg-cover"></div>
              <div className="columns-1 flex flex-col h-[170px] justify-center">
                {/* <div className="text-left text-lg lg:text-xl xl:text-3xl text-white ml-10">
                                    Rede de suporte
                                </div> */}
                <div className="text-left font-bold text-2xl lg:text-4xl xl:text-6xl text-white flex-wrap ml-10">
                  De mulheres <br /> para mulheres
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*begin-history*/}
      <section>
        <div className="flex items-center flex-col lg:flex-row lg:gap-x-10 xl:gap-x-16 bg-primary-50 dark:bg-gray-400 justify-between py-[54px] relative bg-x60light-gray gap-y-10 px-8 md:px-16 xl:px-40 2xl:px-72 sm:w-auto">
          <div className="flex flex-col gap-y-8 flex-1 grow">
            <div>
              <p className="[font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-transparent text-4xl tracking-[0.80px] leading-[normal]">
                <span className="text-neutral-800 dark:text-white">Nossa </span>
                <span className="text-[#a27f59]">História</span>
              </p>
            </div>
            <div>
              <p className="w-full [font-family:'Poppins-ExtraBold',Helvetica] text-base text-justify leading-6">
                <span className="font-extrabold">Danda Papa </span>
                <span className="[font-family:'Poppins-Regular',Helvetica]">
                  fundadora do Radar & Você criou a comunidade em 2017 em São
                  Paulo, com o objetivo de fomentar negócios e networking para a
                  sua rede de contatos de mães, amigas e empresárias, para que
                  elas tivessem um espaço onde pudessem divulgar seus próprios
                  produtos e serviços.
                </span>
                <span className="[font-family:'Poppins-Regular',Helvetica]">
                  <br />
                  <br />
                  Com o tempo, o grupo evoluiu para um ambiente de troca de
                  Experiências confiáveis e seguras, no qual as integrantes
                  passaram a compartilhar dicas de produtos e serviços que
                  utilizavam no dia a dia.
                </span>
                <span className="[font-family:'Poppins-Regular',Helvetica]">
                  <br />
                  <br />
                  Esse ambiente seguro inspirou a criação do Radar, um Concierge
                  Business exclusivamente feminino, que funciona como uma rede
                  de conexões baseada em referências pessoais seguras e
                  comprovadas pelas próprias integrantes. Essa rede é uma fonte
                  de suporte e confiança para mulheres que buscam informações e
                  recomendações de produtos e serviços de qualidade. Em resumo,
                  aa comunidade Radar é uma rede de suporte de mulheres para
                  mulheres, baseada em confiança e segurança.
                </span>
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-[10px] relative flex-1 grow">
            <iframe
              className="shadow-2xl h-36 w-60 sm:h-60 sm:w-96 lg:h-80 lg:w-full rounded-lg"
              width="1024"
              height="720"
              src="https://www.youtube.com/embed/vz3gMi3i2Ck?si=LqLK8mYLGYfH79nK"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>
      </section>
      {/*begin-founder*/}

      <section className="flex flex-1 py-32 px-8 md:px-16 xl:px-40 2xl:px-72 bg-[#262626] flex-col">
        {!loading && createFundadora()}
      </section>

      <section className="bg-[#A27F59] px-8 md:px-16 xl:px-40 2xl:px-72">
        <div className="flex flex-col gap-y-2 py-10 w-full">
          <p className="text-white text-2xl sm:text-4xl [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]">
            Embaixadoras Radar Brasil
          </p>
          <span className="text-white text-4xl md:text-8xl opacity-40 [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold dark:text-white">
            Quem faz acontecer
          </span>
        </div>
        <div>
          <div className="py-10">
            <div className="flex flex-col gap-y-32 pb-10">
              {!loading && createEmbaixadoras()}
            </div>
          </div>
        </div>
      </section>
      <section className="bg-primary-50 dark:bg-neutral-900/95 px-8 md:px-16 xl:px-40 2xl:px-72">
        <div className="flex flex-col items-end py-[54px] sm:w-auto">
          <p className="text-[#a27f59] text-2xl sm:text-4xl [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal] text-end">
            Embaixadoras Radar Internacional
          </p>
          <span className="text-[#a27f59] text-4xl sm:text-6xl lg:text-8xl opacity-40 [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold dark:text-white text-end">
            Quem faz acontecer
          </span>
        </div>
        <div>
          <div className="py-10">
            <div className="flex flex-col gap-y-32 pb-10">
              {!loading && createEmbaixadorasInternacional()}
            </div>
          </div>
        </div>
      </section>
      {/* Por mulheres, para mulheres */}
      <section className="bg-primary-50 dark:bg-neutral-900/95 px-8 md:px-16 xl:px-40 2xl:px-72" id="perfil-quem-participa">
        <div className="flex flex-col lg:flex-row  justify-between">
          <div className="flex flex-col items-center lg:items-start justify-center py-20 sm:w-auto">
            <p
              className="text-[40px] [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]"
              style={{ fontSize: "35px" }}
            >
              Por mulheres
            </p>
            <p
              className="text-[#A27F59] text-[40px] mt-[-10px] [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]"
              style={{ fontSize: "35px" }}
            >
              Para mulheres
            </p>
            <p className="text-[20px] w-60 mt-[20px] [font-family:'Poppins-ExtraBold',Helvetica] text-center lg:text-start leading-[normal]">
              Perfil de quem participa na comunidade Radar
            </p>
          </div>
          <div className="lg:mx-20 2xl:w-[30vw] py-[54px]">
            <p className="text-[#A27F59] text-3xl mt-[-10px] [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]">
              O grupo é formado por mulheres
            </p>
            <p className="text-xl mt-[20px] text-justify [font-family:'Poppins-ExtraBold',Helvetica]">
              Antenadas, dinâmicos, viajadas, cultas e independentes Gostam de
              exclusividade e prezam pelo próprio lifestyle e auto-cuidado, Elas
              são donas de casa, empresarias e executivas do mercado
              corporativa, com autonomia e segurança financeira.
              <br /> <br />
              Estão sempre ataretadas e envolvidas em causas socials muitos
              projetos, eventos e compromissos: Elas conhecem os melhores
              roteiros, hotéis e restaurantes no mundo são antenadas e
              conectadas com o que há de mais novo em termos de produtos e
              serviços. Usam o tempo como artigo de luxo e desfrutam com
              tranquilidade o que a vida tem de melhor para oferecer.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row lg:flex-col justify-center items-center gap-y-6 gap-x-2 mb-16 mt-12">
            <div className="bg-[#A27F59] w-36 h-12 rounded-lg flex justify-center items-center text-center">
              <span className="text-white font-medium">100% mulheres</span>
            </div>
            <div className="bg-[#A27F59] w-36 h-12 rounded-lg flex justify-center items-center text-center">
              <span className="text-white font-medium">Idade 30+</span>
            </div>
            <div className="bg-[#A27F59] w-36 h-12 rounded-lg flex justify-center items-center text-center">
              <span className="text-white font-medium">Dinâmicas</span>
            </div>
            <div className="bg-[#A27F59] w-36 h-12 rounded-lg flex justify-center items-center text-center">
              <span className="text-white font-medium">Viajadas</span>
            </div>
            <div className="bg-[#A27F59] w-36 h-12 rounded-lg flex justify-center items-center text-center">
              <span className="text-white font-medium">Independentes</span>
            </div>
            <div className="bg-[#A27F59] w-36 h-12 rounded-lg flex justify-center items-center text-center">
              <span className="text-white font-medium">Cultas</span>
            </div>
          </div>
        </div>
      </section>
      {/* <div id={'nosso_alcance'} className="relative px-8 md:px-16 xl:px-40 2xl:px-72 py-16">
                <SectionStatistic institutional={institutional} />
            </div> */}
      {/* Quero ser uma Radar */}
      <section
        className="bg-cover bg-bottom w-full"
        style={{ backgroundImage: `url(${banner2})` }}
      >
        <div className="px-8 md:px-16 xl:px-40 2xl:px-72 flex flex-col py-40 justify-between gap-y-20 items-center backdrop-sepia backdrop-blur-sm backdrop-brightness-50 w-full">
          <div className="flex flex-col justify-center items-center text-center gap-y-3">
            <div>
              <span className="text-[#A27F59] text-[40px] [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]">
                Quero ser uma
              </span>
              <span className="text-white ml-4 text-[40px] [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]">
                Radar
              </span>
            </div>
            <span className="text-white text-[16px] [font-family:'Poppins-ExtraBold',Helvetica] leading-[normal]">
              Faça parte da maior e mais influente rede de conexões de mulheres
              do Brasil
            </span>
          </div>
          <div className="flex justify-between items-center">
            <img
              className="w-[85px] h-[85px] mt-[-10rem] mr-[-2rem]"
              alt="Arrow back ios new"
              src={ArrowBackIos}
            />
            <div className="flex w-[45vw]">
              <span className="text-white sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl text-center [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold">
                <b style={{ fontSize: "25px" }}>
                  "Queremos empoderar e impactar o maior número de mulheres."
                </b>
              </span>
            </div>
            <img
              className="w-[85px] h-[85px] rotate-180 mb-[-10rem] ml-[-2rem]"
              alt="Arrow back ios new"
              src={ArrowBackIos}
            />
          </div>

          <Link
            href={"/cadastro"}
            className="w-fit rounded-full bg-primary-900 text-white px-4 py-3 hover:bg-primary-600"
          >
            Quero entrar para o Radar
          </Link>
        </div>
      </section>
    </div>
  );
};
export default AboutUs;
